<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="poll icon"></i>
      {{ $t("rating template") }}
    </div>
    <div class="image scrolling content">
      <!-- <div class="ui small image">
        <img src="/images/icons/template.png" style="width: 100% !important" />
      </div> -->
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="fields">
            <div class="five wide field">
              <label for="">{{ $t("name") }}</label>
              <input type="text" name="name" v-model="name" />
            </div>
            <div class="four wide field">
              <label for="">{{ $t("maximum unevaluated aspects") }}</label>
              <input
                type="text"
                name="max_unevaluated"
                v-model="max_unevaluated"
              />
            </div>
            <div class="seven wide field">
              <label for="">{{ $t("description") }}</label>
              <textarea
                name="description"
                rows="2"
                v-model="description"
              ></textarea>
            </div>
            <!-- <div class="four wide field">
              <div class="fields">
                <div class="ten wide field">
                  <label for="">{{ $t("logo") }}</label>
                  <file-uploader
                    name="file"
                    url="/staff_rating/template/do-upload-logo"
                    @error="error_uploading"
                    @uploaded="end_uploading"
                  />
                </div>
                <img
                  v-if="logo && logo.relative_path"
                  class="ui small image"
                  :src="api_host + '/' + logo.relative_path"
                />
              </div>
            </div> -->
          </div>
          <items :items="items" :categories="categories" />
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated red icon right labeled button"
        @click="remove"
        v-show="uuid"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, api_host } from "@/utils";
import Items from "./Items.vue";
// import FileUploader from "@/components/FileUploader.vue";
// import Swatches from "vue-swatches";

export default {
  name: "StaffRatingTemplateModalIndex",
  components: { Items /* FileUploader */ },
  props: { module_configuration: Object },
  computed: {
    api_host() {
      return api_host;
    },
  },
  data() {
    return {
      name: "",
      max_unevaluated: 0,
      description: "",
      // logo: {},
      items: [],
      form: undefined,
      uuid: "",
      categories: [],
    };
  },
  methods: {
    // error_uploading(err) {
    //   error_toast(err);
    // },
    // end_uploading(file) {
    //   let vm = this;
    //   vm.logo = file;
    // },
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        // console.log(data);
        if (data.uuid) vm.uuid = data.uuid;
        if (data.name) vm.name = data.name;
        if (data.setup.items) vm.items = data.setup.items;
        if (data.setup.max_unevaluated)
          vm.max_unevaluated = data.setup.max_unevaluated;
        // if (data.setup.logo) vm.logo = data.setup.logo;
        if (data.setup.description) vm.description = data.setup.description;
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            // setTimeout(() => {}, 300);
          },
          onHide() {
            vm.form.form("reset");
            vm.name = "";
            vm.max_unevaluated = "";
            // vm.logo = {};
            vm.description = "";
            vm.items = [];
            vm.form = undefined;
            vm.uuid = "";
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          max_unevaluated: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/staff_rating/template/do-save", {
          n: vm.name,
          u: vm.max_unevaluated,
          d: vm.description,
          // l: vm.logo,
          it: vm.items,
          i: vm.uuid,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove template?"),
        function() {
          local_api(vm, "post", "/staff_rating/template/do-remove", {
            u: vm.uuid,
          })
            .then(() => {
              vm.$emit("deleted");
              window.jQuery(vm.$refs.modal).modal("hide");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/staff_rating/template/do-get-categories", {})
      .then((categories) => {
        vm.categories = categories;
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function() {},
};
</script>
